// extracted by mini-css-extract-plugin
module.exports = {"progress-tasks":"_9QGgA","task":"_7+dwv","clickable":"UYzM5","status-done":"IrJqz","dot":"_6KokT","disable-none":"X-RGC","status-in_progress":"WLMXZ","label":"MX1wI"};